module.exports = __webpack_public_path__ + "img/nadia_menotti.8ace268e.png";